import merge from 'deepmerge'
import CobroxCrudRoutes from './CobroxCrudRoutes'
import CobroxRoutes from './CobroxRoutes'

const routes = merge.all([CobroxCrudRoutes,CobroxRoutes])


export default routes;

